import React, { useContext, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';

import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';

const DeleteCategoryModal = ({ modalDetails }) => {
  const data = modalDetails;
  const { categoryId } = data;
  
  const modalCtx = useContext(ModalContext);
  const authCtx = useContext(AuthContext);
  
  const [isDeleting, setIsDeleting] = useState(false);

  const closeHandle = () => {
    modalCtx.closeModal();
  };

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      
      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/category/${categoryId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authCtx.token}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to delete category');
      }

      const result = await response.json();
      console.log('Category deleted successfully:', result);
      
      // Trigger page refresh
      modalCtx.setPageUpdate({ page: "Categories", categoryId: categoryId });
      
      // Close modal
      closeHandle();
      
    } catch (error) {
      console.error('Error deleting category:', error);
      // You might want to show an error message to the user here
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="modal-container">
      <div className='modal-header'>
        <h1>Delete Category</h1>
      </div>
      <div className="modal-body">
        <span>Are you sure you want to delete this category?</span><br/>
        {/* <span style={{fontSize: "12px", color: "#555"}}>
          Deleting this category will automatically detach it from all parent categories and remove it from any listings where it appears.
        </span> */}
      </div>
      <div className="modal-footer">
        <Button className="cancel-btn" onClick={closeHandle} disabled={isDeleting}>CANCEL</Button>
        <Button onClick={handleDelete} disabled={isDeleting} variant="contained">
          {isDeleting ? <CircularProgress size={16} color="inherit" /> : "DELETE"}
        </Button>
      </div>
    </div>
  );
};

export default DeleteCategoryModal;
